import React from 'react'
import {TemplateTextContent} from "./TemplateTextContent";

const TemplateTwo = ({activeTemplate, toggleModal, content, image1, image2, buttonComp, displayEditContentButton, publishActiveTemplate, canCustomize}) => {
  return (
    <div className='row template_two'>
      <div className={`col-md-7 col-sm-12 `}>
        <TemplateTextContent
          toggleModal={toggleModal}
          content={content}
          buttonComp={buttonComp}
          displayEditContentButton={displayEditContentButton}
          activeTemplate={activeTemplate}
          publishActiveTemplate={publishActiveTemplate}
          canCustomize={canCustomize}
        />
      </div>
      <div className={`col-md-5 col-sm-12 `}>
        <figure className='figure_img top'><img
          src={image1} alt='nine to know placeholder'/>
        </figure>
        <figure className='figure_img bottom'><img
          src={image2} alt='nine to know placeholder'/>
        </figure>
      </div>
    </div>
  )
}

export default TemplateTwo
